<template>
  <gg-card>
    <gg-card-header>
      Refer & Earn
    </gg-card-header>
    <gg-card-text>
      <div id="affiliates-top-banner">
        <div class="d-flex flex-column">
          <div class="text-center">
            <template v-if="hasAffiliateAccount">
              <div class="py-3">
                <span class="d-block pb-2">You’ve earned this month:</span>
                <span class="font-weight-light d-block affiliate-earned py-6 primary--text">
                  {{ paidCommission }}
                </span>
                <span class="d-block pb-2">Your Referral Link:</span>
                <span ref="affiliateUrl">
                  https://www.greengeeks.com/track/{{ SessionProfile.affiliate_username }}
                </span>
                <gg-btn icon @click="copyToClipboard('affiliateUrl')">
                  <span class="visually-hidden">Copy</span>
                  <v-icon small>mdi-content-copy</v-icon>
                </gg-btn>
              </div>
            </template>
            <template v-else>
              <div class="py-3">
                <h4 class="d-block text-center mb-6 font-weight-light">
                  Refer your family and friends and earn money.
                </h4>
                <gg-btn :to="{ name: 'affiliates' }" class="px-5">
                  Get Link
                </gg-btn>
              </div>
            </template>
          </div>
        </div>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { moneyFormat } from '@/helpers/helpers'

export default {
  name: 'TopBanner',
  computed: {
    ...mapGetters(['SessionProfile']),
    hasAffiliateAccount () {
      return !!this.SessionProfile.affiliate_username
    },
    paidCommission () {
      return moneyFormat(this.SessionProfile.paid_commission || 0)
    }
  },
  methods: {
    ...mapActions(['reportSuccess']),
    copyToClipboard (text) {
      const toCopy = this.$refs[text]
      navigator.clipboard.writeText(toCopy.innerHTML)
      this.reportSuccess('Copied')
    }
  }
}
</script>

<style scoped>
.affiliate-earned {
  font-size: 48px;
}
</style>
